import React from 'react';

const VehicleCard = ({ vehicle }) => {
  const statusColors = {
    Disponible: 'bg-green-100 text-green-800',
    'En taller': 'bg-yellow-100 text-yellow-800',
    'En viaje': 'bg-blue-100 text-blue-800'
  };

  // Validación segura para el kilometraje
  const safeMileage = vehicle?.currentMileage || 0;
  const formattedMileage = safeMileage.toLocaleString('es-MX');

  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow">
      <div className="p-6">
        <div className="flex justify-between items-start">
          <div>
            <h3 className="text-xl font-bold text-gray-900">{vehicle.brand} {vehicle.model}</h3>
            <p className="text-gray-500">{vehicle.year} • {vehicle.color}</p>
          </div>
          <span className={`px-3 py-1 rounded-full text-xs font-semibold ${statusColors[vehicle.status]}`}>
            {vehicle.status}
          </span>
        </div>
        
        <div className="mt-4 grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-500">Placa</p>
            <p className="font-medium">{vehicle.plate}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Kilometraje</p>
            <p className="font-medium">{formattedMileage} km</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Último servicio</p>
            <p className="font-medium">{vehicle.lastService || 'No registrado'}</p>
          </div>
        </div>

        {/* Barra de progreso de kilometraje */}
        <div className="mt-4">
          <div className="flex justify-between text-sm text-gray-500 mb-1">
            <span>0 km</span>
            <span>100,000 km</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div 
              className="bg-blue-600 h-2.5 rounded-full" 
              style={{ width: `${Math.min(100, (safeMileage / 100000) * 100)}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleCard;

// DONE